export default [
  {text:'ReefTrack v1',value:'ReefTrack v1'},
  {text:'CoolMon Mini',value:'CoolMon Mini'},
]

